import type { TIconProps } from "./types";

export const User = (props: TIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 66 66"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_660_66339)">
        <path
          opacity={0.997}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.9707 -0.0644531C31.9472 -0.0644531 33.9239 -0.0644531 35.9004 -0.0644531C47.4561 1.33907 56.1572 7.05392 62.0039 17.0801C64.156 21.1369 65.4665 25.4337 65.9355 29.9707C65.9355 31.9472 65.9355 33.9239 65.9355 35.9004C65.7838 37.1139 65.5689 38.317 65.291 39.5098C65.3113 39.3328 65.2897 39.1608 65.2266 38.9941C57.0948 30.7978 48.9092 22.6767 40.6699 14.6309C37.9399 11.3073 34.4595 10.1257 30.2285 11.0859C26.6318 12.3254 24.3759 14.7961 23.4609 18.498C22.9355 22.3833 24.1601 25.563 27.1348 28.0371C28.2458 29.234 29.406 30.3942 30.6152 31.5176C22.5542 32.787 16.8179 37.1269 13.4062 44.5371C12.6838 46.4093 12.2326 48.3429 12.0527 50.3379C17.0372 55.3652 22.0214 60.3926 27.0059 65.4199C17.4471 63.5268 10.035 58.4995 4.76953 50.3379C2.0855 45.8736 0.474167 41.0612 -0.0644531 35.9004C-0.0644531 33.9239 -0.0644531 31.9472 -0.0644531 29.9707C1.33901 18.4152 7.05385 9.71403 17.0801 3.86719C21.1369 1.71514 25.4337 0.404585 29.9707 -0.0644531Z"
          fill="var(--user-icon-fill-1)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.67 14.6308C42.7548 17.8178 43.0341 21.1694 41.5078 24.6855C39.6093 28.074 36.7089 29.7928 32.8067 29.8418C30.7002 29.8843 28.8097 29.2827 27.1348 28.0371C24.1602 25.563 22.9355 22.3833 23.461 18.498C24.3759 14.7961 26.6318 12.3254 30.2285 11.0859C34.4595 10.1257 37.94 11.3073 40.67 14.6308Z"
          fill="var(--user-icon-fill-3)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.6699 14.6309C48.9092 22.6767 57.0948 30.7978 65.2266 38.9941C65.2897 39.1608 65.3113 39.3328 65.291 39.5098C62.7886 50.7228 56.3003 58.6935 45.8262 63.4219C42.6191 64.7285 39.3105 65.5664 35.9004 65.9355C33.9239 65.9355 31.9472 65.9355 29.9707 65.9355C28.9895 65.7962 28.0011 65.6242 27.0059 65.4199C22.0214 60.3926 17.0372 55.3652 12.0527 50.3379C22.7012 52.638 33.4433 53.175 44.2793 51.9492C47.4906 51.5862 50.6703 51.0491 53.8184 50.3379C52.9577 43.3048 49.5201 37.9552 43.5059 34.2891C39.4863 32.1027 35.1895 31.1789 30.6152 31.5176C29.406 30.3942 28.2458 29.234 27.1348 28.0371C28.8096 29.2827 30.7002 29.8843 32.8066 29.8418C36.7089 29.7928 39.6093 28.074 41.5078 24.6855C43.0341 21.1694 42.7547 17.8178 40.6699 14.6309Z"
          fill="var(--user-icon-fill-2)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.6152 31.5176C35.1895 31.179 39.4863 32.1027 43.5059 34.2891C49.5201 37.9552 52.9577 43.3048 53.8184 50.3379C50.6703 51.0491 47.4906 51.5862 44.2793 51.9492C33.4433 53.175 22.7012 52.638 12.0527 50.3379C12.2326 48.343 12.6838 46.4094 13.4062 44.5371C16.8179 37.1269 22.5542 32.7871 30.6152 31.5176Z"
          fill="var(--user-icon-fill-3)"
        />
      </g>
      <defs>
        <clipPath id="clip0_660_66339">
          <rect width={66} height={66} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
